module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-platform"
  }, [_c('div', {
    staticClass: "u-relative u-zindex--3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "p-platform__roadmap-container u-relative u-bg--black-near"
  }, [_c('div', {
    staticClass: "p-platform__roadmap-container__wrapper u-marg-x-auto u-w8of12 u-w10of12@sm"
  }, [_c('div', {
    staticClass: "p-platform__roadmap-container__wrapper__title u-marg-t-sm u-color--white t-fweight--light"
  }, [_vm._v("TGE Roadmap")]), _vm._v(" "), _c('div', {
    staticClass: "p-platform__roadmap-container__wrapper__description u-marg-t-sm u-w1of2 u-fit-w@sm u-color--text u-lheight--185p"
  }, [_vm._v("\n                    This is a high-level overview of Practical's milestones leading up to the Token Generation Event. We expect to fully launch PRAX and acommpanying network within 6-8 months of completion of our pre-sale and venture round.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "p-platform__roadmap-container__wrapper__list u-marg-t-xxl u-flex u-flex-fd--column"
  }, _vm._l((_vm.roadmapItems), function(item, index) {
    return _c('div', {
      staticClass: "p-platform__roadmap-container__wrapper__list__item u-flex u-flex-fd--column@sm u-flex-ai--start u-color--white"
    }, [_c('div', {
      staticClass: "u-flex u-flex-fd--column@sm u-flex-ai--center u-flex-ai--start@sm u-w1of2 u-fit-w@sm"
    }, [_c('div', {
      staticClass: "p-platform__roadmap-container__wrapper__list__item-number u-w1of3 u-fit-w@sm t-ffamily--simplon t-fsize--xs u-uppercase",
      domProps: {
        "innerHTML": _vm._s(index + 1 < 10 ? '0' + (index + 1) : (index + 1))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "p-platform__roadmap-container__wrapper__list__item-image u-marg-t-md@sm u-w1of3 u-w1of4@sm u-w1of2@xs"
    }, [_c('img', {
      staticClass: "u-fit-w",
      attrs: {
        "src": '/static/images/platform-icon-' + item.image + '.png',
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "u-marg-t-sm@sm u-w1of2 u-fit-w@sm"
    }, [_c('div', {
      staticClass: "p-platform__roadmap-container__wrapper__list__item-title t-fweight--light u-lheight--185p",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "p-platform__roadmap-container__wrapper__list__item-content u-marg-t-sm u-marg-t-xxs@sm u-lheight--185p u-opacity--30",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  }))])]), _vm._v(" "), _c('app-newsletter'), _vm._v(" "), _c('app-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-platform__top u-marg-x-auto u-w8of12 u-w10of12@lg"
  }, [_c('div', {
    staticClass: "p-platform__top-section u-relative js-section"
  }, [_c('div', {
    staticClass: "p-platform__top-content u-w6of12 u-w8of12@xl u-fit-w@md"
  }, [_c('h1', {
    staticClass: "p-platform__header-container__title u-inline-block t-fweight--light u-color--white"
  }, [_c('div', {
    staticClass: "p-platform__header-container__title--1"
  }, [_vm._v("Building a Better")]), _vm._v(" "), _c('div', {
    staticClass: "p-platform__header-container__title--2"
  }, [_vm._v("Mixed-Reality")])]), _vm._v(" "), _c('div', {
    staticClass: "p-platform__header-container__description u-marg-t-md u-color--text u-lheight--185p"
  }, [_vm._v("\n                        The Practical Ecosystem has two fronts, our first-party application, GATEWAY, and our third-party SDK, KEY SDK. Both of these fronts are loaded with tools that help both users and developers in a mixed reality. We embed crypto-asset wallets on every device to keep anonymity intact, and to deliver a persistent Practical experience across the bounds of applications\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-platform__top-section u-relative js-section"
  }, [_c('div', {
    staticClass: "p-platform__top-content u-w6of12 u-w8of12@xl u-fit-w@md"
  }, [_c('div', {
    staticClass: "p-platform__mapping-container__content-wrapper"
  }, [_c('div', {
    staticClass: "p-platform__mapping-container__content-wrapper__subtitle u-color--white u-uppercase t-fsize--xs t-ffamily--simplon"
  }, [_vm._v("01 / Mapping")]), _vm._v(" "), _c('div', {
    staticClass: "p-platform__mapping-container__content-wrapper__title u-marg-t-sm u-color--white t-fweight--light"
  }, [_c('div', {
    staticClass: "p-platform__objects-container__content-wrapper__title u-marg-t-sm u-color--white t-fweight--light u-uppercase"
  }, [_vm._v("Gateway")])]), _vm._v(" "), _c('div', {
    staticClass: "p-platform__mapping-container__content-wrapper__description u-color--text u-lheight--185p"
  }, [_vm._v("\n                            As our first-party application, GATEWAY provides a simple way to get started with Practical.\n                            "), _c('br'), _vm._v(" "), _c('br'), _c('strong', {
    staticClass: "t-fweight--bold u-color--white"
  }, [_vm._v("• Mining Mode")]), _vm._v(" "), _c('br'), _vm._v("This mode allows users to participate in the act of Spatial Mining to earn PRAX -- watch video \n                            "), _c('br'), _vm._v(" "), _c('br'), _c('strong', {
    staticClass: "t-fweight--bold u-color--white"
  }, [_vm._v("• Build Mode")]), _vm._v(" "), _c('br'), _vm._v("This mode gives users a variety of tools to create in the world around them. Build with blocks or draw with friends, the only limit is your imagination.\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-platform__top-section u-relative js-section"
  }, [_c('div', {
    staticClass: "p-platform__top-content u-w6of12 u-w8of12@xl u-fit-w@md"
  }, [_c('div', {
    staticClass: "p-platform__objects-container__content-wrapper"
  }, [_c('div', {
    staticClass: "u-color--white t-fsize--xs t-ffamily--simplon u-uppercase"
  }, [_vm._v("02 / Objects")]), _vm._v(" "), _c('div', {
    staticClass: "p-platform__objects-container__content-wrapper__title u-marg-t-sm u-color--white u-uppercase t-fweight--light"
  }, [_vm._v("Key "), _c('span', {
    staticClass: "u-color--brand-primary"
  }, [_vm._v("SDK")])]), _vm._v(" "), _c('div', {
    staticClass: "p-platform__objects-container__content-wrapper__description u-color--text u-lheight--185p"
  }, [_vm._v("\n                            KEY SDK takes the innovation from GATEWAY and opens it up for developers to use within their own applications. \n                            "), _c('br'), _vm._v(" "), _c('br'), _c('strong', {
    staticClass: "t-fweight--bold u-color--white"
  }, [_vm._v("• Mapping & Customization Engine")]), _vm._v(" "), _c('br'), _vm._v("In less than a minute, mixed reality developers can have an advanced mapping experience built into their application and start exploring a variety of themes and customizations. \n                            "), _c('br'), _vm._v(" "), _c('br'), _c('strong', {
    staticClass: "t-fweight--bold u-color--white"
  }, [_vm._v("• Spatial Placement Tool")]), _vm._v(" "), _c('br'), _vm._v("We've made it easy for applications to become more environment aware. Easily find locations on walls, the floor, ceiling, couches, tables, chairs, and more.\n                        ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3db98842"}!./src/scripts/components/page-platform/template.html
// module id = 463
// module chunks = 0